import axios from "axios";
import { useURL } from "../data/Config";
import { IEmployer, IPasswordUpdate, IProfessional, IUser } from "../types";
import { ProfileFormData } from "../pages/settings";

interface IUserCount {
  totalUsers: number;
  totalEmployers: number;
  totalProfessionals: number;
}

export interface IAdminData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

interface IAddAdminResponse {
  success: string;
  admin: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
  };
}

export const addAdminUser = async (
  adminData: IAdminData
): Promise<IAddAdminResponse> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  try {
    const response = await axios.post<IAddAdminResponse>(
      `${useURL}/users/admin/add`,
      adminData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error adding admin user:", error);
    throw error;
  }
};

export const activateUser = async (
  id: string
): Promise<{ success: string }> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  try {
    const response = await axios.patch(
      `${useURL}/users/admin/activate/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error activating user:", error);
    throw error;
  }
};

export const suspendUser = async (id: string): Promise<{ success: string }> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  try {
    const response = await axios.patch(
      `${useURL}/users/admin/suspend/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error suspending user:", error);
    throw error;
  }
};

export const updateUserPassword = async (data: IPasswordUpdate) => {
  const token = localStorage.getItem("AUTH_TOKEN");
  try {
    const response = await axios.patch<{ success: string }>(
      `${useURL}/users/update-password`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    console.log(error);
    throw error;
  }
};

export const updateUser = async (
  data: ProfileFormData
): Promise<{ success: string }> => {
  const token = localStorage.getItem("AUTH_TOKEN");
  try {
    const response = await axios.patch(`${useURL}/users/update-user`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    console.log(error);
    throw error;
  }
};

export const getLoggedInUser = async (): Promise<IUser> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  if (!token) {
    throw new Error("No authentication token found. Please log in.");
  }

  const response = await axios.get(`${useURL}/users/logged-in-user`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getUserCount = async (): Promise<IUserCount> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/users/admin/count`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getAllUsers = async (searchQuery?: string): Promise<IUser[]> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/users/admin/all-users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      searchQuery,
    },
  });

  return response.data.users;
};
export const getUserById = async (
  id: string
): Promise<{ user: IUser; userInfo?: IEmployer | IProfessional }> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/users/admin/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
